module.exports = __webpack_public_path__ + "static/media/08_blanco.9459e89f.svg";